var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('card-header',{attrs:{"title":"Application Evaluation Summary","icon":"fa-sparkles"}}),_c('card-body',{staticClass:"content pb-6",attrs:{"padded":""},domProps:{"innerHTML":_vm._s(_vm.summary)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }